import { createDevextremeDatasource } from '@/letapps-vue/utils/useRestApi';

let store;

export function getFilDatasource() {
  if (!store) {
    store = createDevextremeDatasource('/api/Filer', 'id', {
      paginate: false,
    });
  }

  return store;
}
